<template>
    <div>
        <footer>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-4">
                                <img src="../assets/logos/ebsa-rodape.png" class="img-fluid ebsa-rodape">
                            </div>
                            <div class="col-md-5">
                                <p style="margin-bottom: 15px">Condomínio Empresarial CENU<br>
                                Avenida das Nações Unidas, 12901<br>
                                Torre Oeste, 20º andar - Brooklin Paulista<br>
                                São Paulo - SP - CEP 04578-910</p>
                                <p><b>Central de atendimento:</b> 0300 770 1055 </p>
                                <p><b>Telefones:</b> (11) 3226 0211</p>
                                <p><b>E-mail:</b> atendimento@editoradobrasil.com.br</p>
                                <p><b>WhatsApp:</b> (11) 99329-5316 </p>
                                <p>Segunda a sexta das 8h às 18h.</p>
                            </div>
                            <div class="col-md-3">
                                <h3 class="hide-sm">Redes Sociais</h3>
                                <div class="d-inline socials">
                                    <a href="https://www.facebook.com/editoradobrasil/" target="_blank"><img src="../assets/icons/facebook-square-brands.png" class="img-fluid"></a>
                                </div>
                                <div class="d-inline socials">
                                    <a href="https://www.instagram.com/editoradobrasil_oficial/" target="_blank"><img src="../assets/icons/instagram-brands.png" class="img-fluid"></a>
                                </div>
                                <div class="d-inline socials">
                                    <a href="https://www.youtube.com/user/EditoradoBrasil/" target="_blank"><img src="../assets/icons/youtube-brands.png" class="img-fluid"></a>
                                </div>
                                <div class="d-inline socials">
                                    <a href="https://lojavirtual.editoradobrasil.com.br/" target="_blank"><img src="../assets/icons/shopping-cart-solid.png" class="img-fluid"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>